function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState } from "react";
import { Root as TooltipPrimitiveRoot, Trigger as TooltipPrimitiveTrigger, Portal as TooltipPrimitivePortal, Arrow as TooltipPrimitiveArrow, Content as TooltipPrimitiveContent } from "@radix-ui/react-tooltip";
import PropTypes from "prop-types";
import cc from "classcat";
import { Root as PopoverPrimitiveRoot, Trigger as PopoverPrimitiveTrigger, Portal as PopoverPrimitivePortal, Arrow as PopoverPrimitiveArrow, Content as PopoverPrimitiveContent } from "@radix-ui/react-popover";
import { twMerge } from "tailwind-merge";
import { useSelector } from "react-redux";
import { screenBreakpointsSelectors } from "../../../redux/screenBreakpoints";
Tooltip.propTypes = {
    children: PropTypes.node.isRequired,
    trigger: PropTypes.oneOf([
        "hover",
        "click"
    ]),
    hoverWrapperType: PropTypes.string,
    content: PropTypes.node,
    ariaLabel: PropTypes.string,
    side: PropTypes.oneOf([
        "top",
        "right",
        "bottom",
        "left"
    ]),
    sideOffset: PropTypes.number,
    align: PropTypes.oneOf([
        "start",
        "center",
        "end"
    ]),
    alignOffset: PropTypes.number,
    className: PropTypes.string
};
export default function Tooltip(param) {
    var children = param.children, _param_trigger = param.trigger, trigger = _param_trigger === void 0 ? "hover" : _param_trigger, content = param.content, ariaLabel = param.ariaLabel, _param_side = param.side, side = _param_side === void 0 ? "top" : _param_side, sideOffset = param.sideOffset, align = param.align, alignOffset = param.alignOffset, className = param.className;
    var _useState = _sliced_to_array(useState(false), 2), fadeIn = _useState[0], setFadeIn = _useState[1];
    var overLg = useSelector(screenBreakpointsSelectors.isOver("lg"));
    if (content === null) {
        return children;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, (trigger === "click" || !overLg) && /*#__PURE__*/ React.createElement(PopoverPrimitiveRoot, {
        onOpenChange: function(isOpen) {
            return setFadeIn(isOpen);
        }
    }, /*#__PURE__*/ React.createElement(PopoverPrimitiveTrigger, {
        asChild: true
    }, children), /*#__PURE__*/ React.createElement(PopoverPrimitivePortal, null, /*#__PURE__*/ React.createElement(PopoverPrimitiveContent, {
        side: side || "top",
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        className: cc([
            "z-50 mx-3 max-w-[330px] break-words rounded-md bg-black px-5 py-4 font-medium text-gray-200 shadow-around transition-all duration-200 dark:bg-white dark:text-black sm:max-w-md",
            {
                "visible origin-[var(--radix-popover-content-transform-origin)] opacity-100": fadeIn
            },
            {
                "invisible opacity-0": !fadeIn
            },
            className
        ])
    }, /*#__PURE__*/ React.createElement(PopoverPrimitiveArrow, {
        className: twMerge(cc([
            "fill-black dark:fill-white"
        ])),
        width: 8,
        height: 6
    }), content))), trigger === "hover" && overLg && /*#__PURE__*/ React.createElement(TooltipPrimitiveRoot, {
        delayDuration: 400,
        onOpenChange: setFadeIn
    }, /*#__PURE__*/ React.createElement(TooltipPrimitiveTrigger, {
        asChild: true
    }, children), /*#__PURE__*/ React.createElement(TooltipPrimitivePortal, null, /*#__PURE__*/ React.createElement(TooltipPrimitiveContent, {
        className: twMerge(cc([
            "z-50 mx-10 max-w-md break-words rounded-md bg-black px-5 py-4 font-medium text-gray-200 shadow-around transition-all duration-200 dark:bg-white dark:text-black",
            {
                "visible origin-[var(--radix-tooltip-content-transform-origin)] opacity-100": fadeIn
            },
            {
                "invisible opacity-0": !fadeIn
            },
            className
        ])),
        "aria-label": ariaLabel,
        side: side || "bottom",
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset
    }, content, /*#__PURE__*/ React.createElement(TooltipPrimitiveArrow, {
        className: twMerge(cc([
            "fill-black dark:fill-white"
        ])),
        width: 8,
        height: 6
    })))));
}
